module.exports = __webpack_public_path__ + "static/media/persona-1.5dfabc24.png";